import React, {useState, useEffect} from "react";
import { Button, Paper, TextField, Typography } from '@mui/material';
import { useAuth } from "../../Context/AuthContext";
import Alerta from "../../../components/Alerta";
import { db } from "../../../firebase/firebaseConfig";
import { collection, addDoc, doc, getDoc } from 'firebase/firestore';

const FormularioCaracteristicasProducto = ({infoCaracteristicaProductoSeleccionado}) => {
    const isItem = true;
    const [titulo, setTitulo] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const {usuario} = useAuth();
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [alerta, setAlerta] = useState({});
    const [modoEdicion, setModoEdicion] = useState(false); // Variable de estado para el modo de edición

    useEffect(() => {
        const obtenerCaracterisricaProducto = async () => {
          if (!infoCaracteristicaProductoSeleccionado) return; // Asegúrate de que haya un infoCaracteristicaProductoSeleccionado seleccionado
          try {
            const infoCaracteristicaProductoDoc = await getDoc(doc(db, 'infocaracteristicaproductocalocho', infoCaracteristicaProductoSeleccionado));
            if (infoCaracteristicaProductoDoc.exists()) {
                setModoEdicion(true);
                const infoCaracteristicaProductoData = infoCaracteristicaProductoDoc.data();
                setTitulo(infoCaracteristicaProductoData.titulo || '');
                setDescripcion(infoCaracteristicaProductoData.descripcion || '');
            } else {
              setModoEdicion(false);
            }
          } catch (error) {
          }
        };
      
        obtenerCaracterisricaProducto();
    }, [infoCaracteristicaProductoSeleccionado]); // Asegúrate de que useEffect se ejecute cuando cambie infoCaracteristicaProductoSeleccionado
      
    const handleChange = (e) => {
        if(e.target.name === 'titulo'){
            setTitulo(e.target.value);
        } else if(e.target.name === 'descripcion'){
            setDescripcion(e.target.value);
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        try {

            if(modoEdicion && infoCaracteristicaProductoSeleccionado.id){

                // Cambiar el estado de modoEdicion a falso para volver al modo de creación
                setModoEdicion(false);
                
                // Limpiar el formulario después de agregar el infocaracteristicaproducto
                setTitulo('');
                setDescripcion('');
                infoCaracteristicaProductoSeleccionado('');
                // Mostrar mensaje de éxito
                setEstadoAlerta(true);
                setAlerta({ tipo: 'exito', mensaje: 'infocaracteristicaproducto actualizado correctamente' });
            
            } else {
                
                // Agregar el infocaracteristicaproducto a Firestore con la URL de la imagen
                await addDoc(collection(db, 'infocaracteristicaproductocalocho'), {
                    titulo: titulo,
                    descripcion: descripcion,
                    uidUsuario: usuario.uid
                });

                // Limpiar el formulario después de agregar el infocaracteristicaproducto
                setTitulo('');
                setDescripcion('');

                // Mostrar mensaje de éxito
                setEstadoAlerta(true);
                setAlerta({ tipo: 'exito', mensaje: 'infocaracteristicaproducto agregado correctamente' });
        
            }

            // Limpiar el formulario después de agregar el infocaracteristicaproducto
            setTitulo('');
            setDescripcion('');

        } catch (error) {
            console.error(error);
            setEstadoAlerta(true);
            setAlerta({ tipo: 'error', mensaje: 'Error al agregar el infocaracteristicaproducto' });
        }
    }

    return (
        <Paper onSubmit={handleSubmit} component="form" sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '90%',
            maxWidth: '500px',
            margin: 'auto',
            padding: 2,
            boxShadow: 3,
            borderRadius: 2,
            gap: 2,
            // Añadimos media queries aquí
            '@media (max-width: 1024px)': { // Tablets
                width: '95%',  // Ocupar un poco más de ancho
                padding: 1,  // Reducir el padding
            },
            '@media (max-width: 600px)': {  // Móviles
                width: '100%',  // Ocupar todo el ancho
                padding: 1,  // Padding más pequeño
            },
        }}>
            <Typography variant='h5' sx={{
                width: 'auto',
                alignItems: 'center',
                textAlign: 'center',
                '@media (max-width: 600px)': {  // En móviles, reducir el tamaño del texto
                    fontSize: '1.25rem',  // Ajustamos el tamaño de la fuente
                }
            }}>Nuestra infomación de la tarjetas de Features</Typography>
            <TextField                  
                required
                fullWidth
                size="small"
                id="titulo"
                label="titulo"
                name="titulo"
                value={titulo}
                onChange={handleChange}/>

            <TextField                  
                required
                size="small"
                fullWidth
                id="descripcion"
                multiline
                label="Descripción de la información caracteristicas de producto"
                name="descripcion"
                value={descripcion}
                onChange={handleChange}/>

            <Button item={isItem.toString()} xs={12} sm={6}           
                type="submit"
                fullWidth
                size="small"
                variant="outlined"
            >{infoCaracteristicaProductoSeleccionado ? 'Editar información' : 'Agregar información'}</Button>
            <Alerta 
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                setAlerta={setEstadoAlerta}
            />
        </Paper>
    );
}

export default FormularioCaracteristicasProducto;